import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import type {  AxiosRequestConfig } from "axios";

import { MixInterface } from "../entities/Mix";
import { CommonResponseInterface } from "../entities/Common";

export enum MixEndpoints {
  MIX_BY_FUCHS = "mix/byFuchs",
  MIX_BY_WEBSHOP = "mix/webshop",
}

export class MixService {
  static getMixesByWebshop(id: string | number): Promise<MixInterface[]> {
    return request({
      url: `${MixEndpoints.MIX_BY_WEBSHOP}/${id}`,
      method: AxiosMethod.GET,
    });
  }

  static getMixByFuchs(id: string): Promise<MixInterface> {
    return request({
      url: `${MixEndpoints.MIX_BY_FUCHS}/${id}`,
      method: AxiosMethod.GET,
    });
  }

  static getMixesByFuchsByCategoryId(
    config?: AxiosRequestConfig,
  ): Promise<CommonResponseInterface<MixInterface>> {
    return request({
      url: `${MixEndpoints.MIX_BY_FUCHS}`,
      method: AxiosMethod.GET,
      params: config?.params,
    });
  }
}
